module.exports = __webpack_public_path__ + "img/wushuju.07dd3f20.png";